import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';


import {PrivacyContent} from './_PrivacyContent.jsx';

export default class PrivacyPolicy extends BLComponent 
{
	constructor (props, context) 
	{
		super(props, context);

		this.state = {
			selectedPolicy: -1
		}

		this.preview = blapp.util.getUrlVar('preview') ? true : false;
	}

	render() 
	{	
		const isPreviewPolicy = PrivacyContent().findIndex(item => item.preview == true) != -1;

		const activePolicies = PrivacyContent().filter(item => item.preview == false).sort((itemA, itemB) => itemA.updated > itemB.updated ? -1 : 1);
		const policy = this.preview && isPreviewPolicy ? PrivacyContent()[PrivacyContent().findIndex(item => item.preview == true)] : this.state.selectedPolicy == -1 ? activePolicies[0] : activePolicies.find(policy => policy.id == this.state.selectedPolicy);
		const policyHistory = activePolicies.map(policy => <option value={policy.id}>{blapp.format.formatDate(policy.updated)}</option>);

		return (
			<div className="main l-margin-y--xxl l-border-round overflow-hidden">
				<div className="main__content l-pad--null">
					<header className="l-pad--xl l-border-bottom l-flex l-split">
						<div>
							<h1 className="text--xl-title">Privacy Policy</h1>
							{this.preview ? 
								<p>New update: {blapp.format.formatDate(policy.updated)}</p>
							:
								<p>Last updated: {blapp.format.formatDate(policy.updated)}</p>
							}
						</div>
						{policyHistory.length > 1 ?
							<label>
								Privacy Policy History:
								<select className="select select--tight l-margin-left--sm" selected={policy.id} onChange={(e) => this.setState({selectedPolicy: e.target.value})}>
									{policyHistory}
								</select>
							</label>
						: null}
					</header>
					<section className="l-pad--xl bg-color--pewter">
						<div className="l-pad--xl bg-color--white l-margin-bottom--xl l-border-round base-formating base-formating--advanced">
							{policy.content}
						</div>
					</section>
				</div>
			</div>
		);
	}

	renderPolicy() 
	{
		
	}	
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<PrivacyPolicy blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-privacypolicy' )
						);
		blapp.refs.register( "main", elem );
	}
);
